<template>
  <v-card :style="backOpacity">
    <v-card-title>通常テキスト plainText.vue</v-card-title>
    <v-card-text>
      <v-container>
        rules:{{ rules }}
        <v-row>
          <v-col cols="3">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              :rules="[]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <set-Cols
              :value="String(returnData.cols)"
              v-on:set="$set(returnData, 'cols', $event)"
            ></set-Cols>
          </v-col>
          <v-col cols="2" v-if="rules2flag">
            <v-checkbox
              v-model="rules[5]"
              label="specialMethod使用"
              value="true"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-checkbox
              v-model="rules[0]"
              label="v-text-filed表示"
              value="true"
            ></v-checkbox>
          </v-col>

          <v-col cols="2">
            <v-checkbox
              v-model="rules2flag"
              label="v-textarea表示"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="rules[1]"
              label="v-cardで囲う"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="2" v-if="rules2flag">
            <v-text-field label="行数" v-model="rules2row"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" v-if="rules[1] == 'true'">
            <v-select
              :items="$store.state.colors"
              item-text="label"
              item-value="value"
              v-model="rules[3]"
              label="card-color"
              :background-color="rules[3]"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="rules2flag">
            <v-select
              :items="color"
              item-text="label"
              item-value="value"
              v-model="rules[3]"
              label="背景色"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="rules2flag">
            <v-select
              :items="color"
              item-text="label"
              item-value="value"
              v-model="rules[4]"
              label="枠色"
            ></v-select>
          </v-col>
        </v-row>
        <!-- --------------------------テキスト表示-------------------------------->
        <div v-if="(rules[0] == null || rules[0] == '') && rules2flag == false">
          <p>{ マスタデータID.IDでマスタデータ表示 }</p>
          <p>{ formID }でmainRecodesか対象フォームの値を表示</p>
          <div v-for="(o, i) in obj" :key="`1-${i}`" class="mb-4">
            <v-row>
              <v-col cols="2">
                <v-select
                  :items="selectType"
                  v-model="o.type"
                  label="type"
                ></v-select>
              </v-col>
              <v-col cols="2" v-if="o.type == 'hr'">
                <v-select
                  :items="lineType"
                  item-text="label"
                  item-value="value"
                  v-model="o.height"
                  label="線の種類"
                ></v-select>
              </v-col>
              <v-col cols="2" v-if="o.type == 'hr'">
                <v-text-field
                  label="線の太さ"
                  v-model="o.align"
                  :rules="[$store.state.validation.numonly]"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="o.type == 'hr'">
                <v-select
                  :items="$store.state.colors"
                  item-text="label"
                  item-value="value"
                  v-model="o.class"
                  label="線の色"
                ></v-select>
              </v-col>
              <v-col cols="2" v-if="o.type != 'hr'">
                <v-select
                  :items="rowType"
                  item-text="label"
                  item-value="value"
                  v-model="o.align"
                  label="並び"
                ></v-select>
              </v-col>
              <v-col cols="2" v-if="o.type != 'hr'">
                <v-select
                  :items="heightType"
                  item-text="label"
                  item-value="value"
                  v-model="o.height"
                  label="高さ"
                ></v-select>
              </v-col>
              <v-col cols="2" v-if="o.type != 'hr'">
                <v-select
                  :items="classType"
                  v-model="o.class"
                  label="type"
                ></v-select>
              </v-col>
              <v-col v-if="o.type != 'hr'">
                <v-text-field
                  label="表示"
                  v-model="o.text"
                  hint="オリジナルコンポーネントを使用する際は「testSub」のように間に大文字を入れてください"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="1">
              <v-btn @click="add" class="ma-2" color="primary">追加</v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn @click="del" class="ma-2" color="red">削除</v-btn>
            </v-col>
          </v-row>
        </div>
        <!-- ----------------------v-text表示表示-------------------------->
        <div v-else-if="rules2flag == false">
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="(同一ページ)マスタデータID"
                v-model="vText.masterID"
                hint=""
                persistent-hint
                :rules="[$store.state.validation.numonly]"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="(マスタページ内)表示するフォームID"
                v-model="vText.formID"
                hint=""
                persistent-hint
                :rules="[$store.state.validation.numonly]"
              ></v-text-field>
            </v-col>
            <!--
            <v-col cols="4" >
              <v-text-field
                label="表示テキスト"
                v-model="vText.text"
                hint="同一ページのチェック対象.メッセージ内容"
                persistent-hint
              ></v-text-field>
            </v-col>
            -->
          </v-row>
        </div>
        <!-- ----------------------v-textarea表示----------------------------- -->
        <v-row v-else>
          <v-col>
            <v-text-field
              label="表示形式"
              v-model="rules2show"
              hint="{formID}で同一ページ内のフォームを表示可能、複数のformID対応可。specialMethod使用時は{formID}が渡される"
              :rules="[]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click="submit"
        right
        x-large
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
  },
  props: {
    label: String,
    type: Number,
    cols: String,
    position: Number,
    //個別値
    value: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: "",
      },
      rules: ["", "", "", "white", "#1976d2"],
      rules2flag: false,
      rules2row: 3,
      rules2show: "",
      //
      vText: {
        masterID: "",
        formID: "",
        text: "",
        option: "",
      },
      //
      obj: [
        {
          type: "v-list-item-title",
          align: "",
          height: "",
          class: "ma-0",
          text: "",
        },
      ],
      selectType: [
        "v-list-item-title",
        "v-list-item-subtitle",
        "originalComponent",
        "hr",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
      ],
      lineType: [
        { label: "実線", value: "solid" },
        { label: "点線", value: "dotted" },
        { label: "破線", value: "dashed" },
        { label: "二重線", value: "double" },
      ],
      rowType: [
        { label: "無し", value: "" },
        { label: "左", value: "left" },
        { label: "中央", value: "center" },
        { label: "右", value: "right" },
      ],
      heightType: [
        { label: "そのまま", value: "" },
        { label: "下げる", value: "three-line" },
      ],
      classType: [
        "ma-0",
        "ma-0 text-h4",
        "ma-0 text-h5",
        "ma-0 text-h6",
        "ml-9",
      ],
      color: [
        { label: "vuetify選択色", value: "#1976d2" },
        { label: "黒色", value: "black" },
        { label: "白色", value: "white" },
        { label: "グレー", value: "rgb(224. 224. 224)" },
      ],
      backOpacity: "opacity: 1",
    };
  },
  mounted() {
    if (this.rule != "" && typeof this.rule != "undefined") {
      this.rules = this.rule.split(",");
    }
    if (this.rules[0] == "true") {
      let tmp = this.returnData.value.split(",");
      this.vText.masterID = tmp[0];
      this.vText.formID = tmp[1];
      this.vText.text = tmp[2];
      this.vText.option = tmp[3];
    } else if (this.value != null && this.value != "") {
      this.obj = JSON.parse(this.value);
    }

    if (this.rules[2] != "") {
      this.rules2flag = true;
      [this.rules2row, this.rules2show] = this.rules[2].split(".");
    }
  },
  methods: {
    submit() {
      if (this.rules2flag) {
        this.rules[2] = this.rules2row + "." + this.rules2show;
      } else {
        this.rules[2] = "";
      }

      this.returnData.rule = this.rules.join(",");
      if (this.rules[0] == "true") {
        this.returnData.value =
          this.vText.masterID +
          "," +
          this.vText.formID +
          "," +
          this.vText.text +
          "," +
          this.vText.option;
      } else {
        this.returnData.value = JSON.stringify(this.obj);
      }
      //---------------------------------------------
      if (this.returnData.value.length < 1024) {
        this.$emit("clickSubmit", this.returnData);
      } else {
        alert("objの文字数が1023を超えています");
      }
    },
    add() {
      if (this.obj.length > -1) {
        const tmp = JSON.parse(JSON.stringify(this.obj[this.obj.length - 1]));
        this.obj.push(tmp);
      }
    },
    del() {
      if (this.obj.length > 1) {
        this.obj.pop();
      }
    },
  },
};
</script>
